import React from 'react';

import { MenuItemType } from 'antd/lib/menu/interface';

import ShopDataModalAddEntry from './ShopDataModalAddEntry';
import DownCaretIcon from '../../../common/Icons/DownCaretIcon';

interface Props {
  label: string;
  options: MenuItemType[];
  dataTestId?: string;
}

const ShopDataModalAddEntryArrow = ({ label, options, dataTestId }: Props) => {
  return (
    <ShopDataModalAddEntry
      label={label}
      options={options}
      content={
        <div
          style={{
            display: 'flex',
            gap: 6,
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--text-primary)',
            fontSize: 12,
          }}
          data-test-id={dataTestId}
        >
          <span>{label}</span>
          <DownCaretIcon />
        </div>
      }
    />
  );
};

export default ShopDataModalAddEntryArrow;
